import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ManagedText } from '@shared/models/managed-text.model';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SnackBarService } from './snack-bar.service';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';

@Injectable({
  providedIn: 'root',
})
export class ManagedTextApiService {
  readonly http = inject(HttpClient);
  private readonly _messageService = inject(SnackBarService);
  readonly url = `${environment.apiUrl}/managed-text`;

  getManagedTextByCategory$(category: string): Observable<ManagedText[]> {
    return this.http.get<ManagedText[]>(`${this.url}/category/${category}`).pipe(
      catchError(error => {
        this._messageService.showError(`Failed to retrieve text:  ${error.error.message ?? GENERAL_ERROR_MESSAGE}.`);
        return of([]);
      })
    );
  }
}
